export default "__VITE_ASSET__DXnHf731__"